/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LobbyMediaItemResponse
 */
export interface LobbyMediaItemResponse {
    /**
     * 
     * @type {string}
     * @memberof LobbyMediaItemResponse
     */
    type: LobbyMediaItemResponseTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof LobbyMediaItemResponse
     */
    assetId?: string;
    /**
     * 
     * @type {string}
     * @memberof LobbyMediaItemResponse
     */
    url: string;
}


/**
 * @export
 */
export const LobbyMediaItemResponseTypeEnum = {
    IMAGE: 'IMAGE',
    VIDEO: 'VIDEO'
} as const;
export type LobbyMediaItemResponseTypeEnum = typeof LobbyMediaItemResponseTypeEnum[keyof typeof LobbyMediaItemResponseTypeEnum];


/**
 * Check if a given object implements the LobbyMediaItemResponse interface.
 */
export function instanceOfLobbyMediaItemResponse(value: object): value is LobbyMediaItemResponse {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function LobbyMediaItemResponseFromJSON(json: any): LobbyMediaItemResponse {
    return LobbyMediaItemResponseFromJSONTyped(json, false);
}

export function LobbyMediaItemResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LobbyMediaItemResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'assetId': json['assetId'] == null ? undefined : json['assetId'],
        'url': json['url'],
    };
}

export function LobbyMediaItemResponseToJSON(json: any): LobbyMediaItemResponse {
    return LobbyMediaItemResponseToJSONTyped(json, false);
}

export function LobbyMediaItemResponseToJSONTyped(value?: LobbyMediaItemResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'assetId': value['assetId'],
        'url': value['url'],
    };
}

